import { RecommendationGender } from '@shared/types/recommendation';
import { Recommendation, RecommendationLegacy } from '@shared/types/recommendation';
import { CategoryTabIds } from './../../mylounge/banner/constants';

export const getGenderByCategoryTabId = (categoryTabId: CategoryTabIds) => {
    if (CategoryTabIds.MEN === categoryTabId) {
        return RecommendationGender.MALE;
    }

    return RecommendationGender.FEMALE;
};

export const convertRecommendationsToLegacy = (
    recommendations: Recommendation[],
): RecommendationLegacy[] => {
    return recommendations
        .filter(
            (recommendation: Recommendation) =>
                recommendation?.images?.length && recommendation?.simples?.length,
        )
        .map(
            (recommendation): RecommendationLegacy => ({
                sku: recommendation.sku,
                urlPath: recommendation.urlPath,
                brand: recommendation.brand,
                brandCode: recommendation.brandCode,
                specialPrice: recommendation.simples[0]?.specialPrice,
                price: recommendation.simples[0]?.price,
                imageUrl: recommendation.images[0],
                campaignIdentifier: recommendation.campaignIdentifier,
                categoryId: recommendation.categoryId,
                plusEarlyAccess: recommendation.plusEarlyAccess,
            }),
        );
};
